
/*
Un manager de alertas
*/
(function errorsModuleDefinition() {

    angular.module('Errors', ['Messages', 'Language']);

})();